import { useToast, Tooltip } from "@aidkitorg/component-library";
import { Square2StackIcon } from "@heroicons/react/24/outline";
import { useMemo } from "react";
import { useLocalizedStrings } from "../Localization";
import { copyToClipboard } from "../Util";
import { HasEnableKey, calcEnableKey, enableKeyIsValid } from "@aidkitorg/types/lib/eval";
import { hash } from "@aidkitorg/types/lib/translation/v0_to_legacy";

export function EnableKey({ component, parts, parentComponent }: { component: HasEnableKey, parts?: string[], parentComponent?: HasEnableKey }) {
  const expected = useMemo(() => Array.isArray(parts) ? [hash(parts.join(''))] : [calcEnableKey(component), calcEnableKey(component, {}, JSON.stringify)], [component, parts]);
  const expectedLegacy = useMemo(() => Array.isArray(parts) ? [hash(parts.join(''))] : [calcEnableKey(component, { version: 'legacy' }), calcEnableKey(component, { version: 'legacy' }, JSON.stringify)], [component, parts]);
  const shouldShowParentDisabledMessage = useMemo(() => {
    if (!parentComponent) return false;

    // This means the true component is enabled, so we do care if the parent is disabled.
    if (expected.includes(component.enableKey) || expectedLegacy.includes(component.enableKey)) {
      return !enableKeyIsValid(parentComponent.enableKey, parentComponent);
    }

    return false;
  }, [parentComponent, component, expected, expectedLegacy]);
  const L = useLocalizedStrings();
  const { toast } = useToast();

  function copy(str: string) {
    const { dismiss } = toast({
      description: `Hash ${L.copied_to_clipboard}`
    });
    copyToClipboard(str);
    setTimeout(() => dismiss(), 1500);
  }

  return <>
    <b>{expected[0] === component.enableKey
      ? 'Enabled'
      : expected[1] === component.enableKey
        ? <span className="text-red-500">Enabled but outdated, please set to <b>{expected[0]}</b></span>
        : (expectedLegacy[0] === component.enableKey) 
          ? 'Enabled (legacy)' 
          : expectedLegacy[1] === component.enableKey
            ? <span className="text-red-500">Enabled (legacy) but outdated, please set to <b>{expected[0]}</b></span>
            : 'Not Enabled. Key is: ' + expected[0]}</b>
    <Tooltip text="Copy Hash to clipboard">
      <Square2StackIcon className="align-super w-5 h-5 cursor-pointer" onClick={() => copy(expected[0])} />
    </Tooltip>
    {shouldShowParentDisabledMessage && <div className="text-red-500 mt-1 text-sm">(Parent Notif not enabled, so flup is not truly enabled)</div>}
  </>
}
